export const getFullName = (applicant) => {
  return `${applicant?.firstName} ${applicant?.lastName}`
}
